import { render, staticRenderFns } from "./contactinfo.vue?vue&type=template&id=bcbe4692"
import script from "./contactinfo.vue?vue&type=script&lang=js"
export * from "./contactinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports